var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.078 5.569a.833.833 0 0 1 1.248 1.1l-.07.079-8.333 8.333c-.3.3-.773.323-1.1.07l-.078-.07-4.167-4.167a.833.833 0 0 1 1.1-1.248l.079.07 3.577 3.576z",
    clipRule: "evenodd"
  })));
};
export default SvgCheck;